import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'
import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import ComparisonBarChart from '../Components/ComparisonBarChart'
import DonutChart from '../Components/DonutChart'
import StackedPileChart from '../Components/StackedPileChart'
import IssueSummaryChart from '../Components/IssueSummaryChart'
import JobStatisticsChart from '../Components/JobStatisticsChart'
import Select from 'react-select'
import Datetime from 'react-datetime'

import ProjectProgressionByMachineView from '../ProjectProgressionByMachine/View'

import useViewModel from './ViewModel'
import moment from 'moment'

const DashboardOverviewView: React.FC = () => {
  const {
    allPileChartData,
    successPileData,
    unsuccessPieChartData,
    StatsTypeOfPile,
    issueData,
    projectStatusData,
    jobStatisticsData,
    successfulPileHolesData,
    successfulPileHolesItemsData,
    // Filters Options
    jobStatisticFilterData,
    setJobStatisticFilterData,
    sales,
    yearOptions,
    projectStateOptions,
    divisionOptions,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    dataTypeOptions,
    dataType,
    setDataType,
    selectedDivision,
    setSelectedDivision,
    selectedProjectState,
    setSelectedProjectState,
  } = useViewModel()

  return (
    <ViewPageTitle>
      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
        </div>

        {/* Filters */}
        <div className='col-12'>
          <div className='card'>
            <div className='card-header'>
              <div className='card-title fw-bolder'>ตัวกรอง</div>
            </div>
            <div className='card-body'>
              <div className='row g-5'>
                <div className='col-12 col-md-6'>
                  <label className='mb-1 fw-bold text-muted fs-7'>วันที่เริ่มต้น</label>
                  <Datetime
                    locale='en'
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                    onChange={date => {
                      if (moment.isMoment(date)) {
                        setStartDate(moment(date).tz('Asia/Bangkok').toDate())
                      }
                    }}
                    value={startDate}
                    renderInput={props => (
                      <input
                        {...props}
                        autoComplete='off'
                        className='form-control form-control-sm'
                        style={{ minWidth: '140px' }}
                        placeholder='เลือกวันที่เริ่มต้น'
                        value={moment(startDate).tz('Asia/Bangkok').format('DD/MM/YYYY')}
                      />
                    )}
                    closeOnClickOutside
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <label className='mb-1 fw-bold text-muted fs-7'>วันที่สิ้นสุด</label>
                  <Datetime
                    locale='en'
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                    onChange={date => {
                      if (moment.isMoment(date)) {
                        setEndDate(moment(date).tz('Asia/Bangkok').toDate())
                      }
                    }}
                    value={endDate}
                    renderInput={props => (
                      <input
                        {...props}
                        autoComplete='off'
                        className='form-control form-control-sm'
                        style={{ minWidth: '140px' }}
                        placeholder='เลือกวันที่สิ้นสุด'
                        value={moment(endDate).tz('Asia/Bangkok').format('DD/MM/YYYY')}
                      />
                    )}
                    closeOnClickOutside
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <label className='mb-1 fw-bold text-muted fs-7'>แสดงมุมมองของข้อมูล</label>
                  <Select
                    value={dataTypeOptions.find(option => option.value === dataType) ?? null}
                    options={dataTypeOptions}
                    onChange={(option: any) => {
                      if (option) {
                        setDataType(option.value as 'month' | 'daily')
                      }
                    }}
                    styles={{
                      control: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        height: '34px !important',
                        minHeight: '34px !important',
                        fontSize: '0.875rem !important',
                      }),
                      singleValue: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      multiValue: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      option: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                    }}
                    isSearchable={false}
                    isClearable={false}
                    placeholder='เลือกมุมมองข้อมูล'
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <label className='mb-1 fw-bold text-muted fs-7'>หน่วยงาน</label>
                  <Select
                    value={divisionOptions.filter(option =>
                      selectedDivision.includes(option.value)
                    )}
                    options={divisionOptions}
                    onChange={(option: any) => {
                      if (option) {
                        setSelectedDivision(option.map((item: any) => item.value))
                      }
                    }}
                    styles={{
                      control: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        height: '34px !important',
                        minHeight: '34px !important',
                        fontSize: '0.875rem !important',
                      }),
                      singleValue: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      multiValue: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      multiValueLabel: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      option: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      placeholder: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                    }}
                    isMulti
                    isSearchable={true}
                    isClearable={true}
                    placeholder='พิมพ์/เลือกหน่วยงาน'
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <label className='mb-1 fw-bold text-muted fs-7'>สถานะของโครงการ</label>
                  <Select
                    value={
                      projectStateOptions.find(option => option.value === selectedProjectState) ??
                      null
                    }
                    options={projectStateOptions}
                    onChange={(option: any) => {
                      setSelectedProjectState(option?.value)
                    }}
                    styles={{
                      control: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        height: '34px !important',
                        minHeight: '34px !important',
                        fontSize: '0.875rem !important',
                      }),
                      singleValue: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      multiValue: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      multiValueLabel: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      option: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                      placeholder: (baseStyles: any, state: any) => ({
                        ...baseStyles,
                        fontSize: '0.875rem !important',
                      }),
                    }}
                    isSearchable={false}
                    isClearable={false}
                    placeholder='สถานะของโครงการ'
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-12'>
          <ProjectProgressionByMachineView />
        </div>

        {/* begin:: All Piles Chart */}
        <div className='col-12'>
          <div className='card h-100'>
            <div className='card-header'>
              {/* Title */}
              <div className='card-title fw-bolder'>จำนวนเสาเข็มของทุกหน่วยงาน</div>
            </div>

            <div className='card-body'>
              {/* Chart */}
              <div className='row align-items-center justify-content-center h-100'>
                <div className='col-12 text-center'>
                  <DonutChart
                    colors={['#FF5B5B', '#2D9CDB', '#F2C94C', '#6FCF97', '#9B51E0']}
                    series={allPileChartData.data}
                    labels={allPileChartData.categories}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end:: All Piles Chart */}

        {/* begin:: Success Pie Chart */}
        <div className='col-xl-6 col-12'>
          <div className='card h-100'>
            <div className='card-header'>
              {/* Title */}
              <div className='card-title fw-bolder'>จำนวนเสาที่ติดตั้งสำเร็จ</div>
            </div>

            <div className='card-body'>
              {/* Chart */}
              <div className='row align-items-center justify-content-center h-100'>
                <div className='col-12 text-center'>
                  <DonutChart
                    colors={['#FF5B5B', '#2D9CDB', '#F2C94C', '#6FCF97', '#9B51E0']}
                    series={successPileData.data}
                    labels={successPileData.categories}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end:: Success Pie Chart */}

        {/* begin:: UnSuccess Pie Chart */}
        <div className='col-xl-6 col-12'>
          <div className='card h-100'>
            <div className='card-header'>
              {/* Title */}
              <div className='card-title fw-bolder'>จำนวนเสาที่ติดตั้งไม่สำเร็จ</div>
            </div>

            <div className='card-body'>
              {/* Chart */}
              <div className='row align-items-center justify-content-center h-100'>
                <div className='col-12 text-center'>
                  <DonutChart
                    colors={['#FF5B5B', '#2D9CDB', '#F2C94C', '#6FCF97', '#9B51E0']}
                    series={unsuccessPieChartData.data}
                    labels={unsuccessPieChartData.categories}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end:: UnSuccess Pie Chart */}

        {/* begin:: Job Statistics (Sale) Chart */}
        <div className='col-12'>
          <div className='card '>
            <div className='card-header'>
              <div className='card-title fw-bolder'>Job Statistics (Sale)</div>
              <div className='card-toolbar w-lg-450px'>
                <div className='row g-5 w-100'>
                  <div className='col-12 col-md-6'>
                    <label className='mb-1 fw-bold text-muted fs-7'>ปี</label>
                    <Select
                      value={
                        yearOptions.find(option => option.value === jobStatisticFilterData.year) ??
                        null
                      }
                      options={yearOptions}
                      onChange={(option: any) => {
                        setJobStatisticFilterData(prev => ({
                          ...prev,
                          year: option?.value ?? moment().tz('Asia/Bangkok').year(),
                        }))
                      }}
                      styles={{
                        control: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          height: '34px !important',
                          minHeight: '34px !important',
                          fontSize: '0.875rem !important',
                        }),
                        placeholder: (baseStyles: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        singleValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        multiValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        option: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                      }}
                      isSearchable={false}
                      isClearable={false}
                      placeholder='เลือกมุมมองข้อมูล'
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </div>

                  <div className='col-12 col-md-6'>
                    <label className='mb-1 fw-bold text-muted fs-7'>ผู้ขาย</label>
                    <Select
                      value={
                        sales.find(option => option.value === jobStatisticFilterData.saleUserId) ??
                        null
                      }
                      options={sales}
                      onChange={(option: any) => {
                        setJobStatisticFilterData(prev => ({
                          ...prev,
                          saleUserId: option?.value ?? null,
                        }))
                      }}
                      styles={{
                        control: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          height: '34px !important',
                          minHeight: '34px !important',
                          fontSize: '0.875rem !important',
                        }),
                        placeholder: (baseStyles: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        singleValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        multiValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        option: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                      }}
                      isSearchable={true}
                      isClearable={true}
                      placeholder='พิมพ์/เลือกผู้ขาย'
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <JobStatisticsChart {...jobStatisticsData} />
            </div>
          </div>
        </div>
        {/* end:: Job Statistics (Sale) Chart */}

        {/* begin:: Stacked Column Chart */}
        <div className='col-12'>
          <div className='card '>
            <div className='card-header'>
              <div className='card-title fw-bolder'>Job Statistics (Type of Piles)</div>
            </div>
            <div className='card-body'>
              <StackedPileChart
                categories={successfulPileHolesData.categories}
                series={successfulPileHolesData.data}
                colors={['#FF5B5B', '#2D9CDB', '#F2C94C', '#6FCF97', '#9B51E0']}
              />
            </div>
          </div>
        </div>
        {/* end:: Stacked Column Chart */}

        {/* begin:: Pile Item Stacked Chart */}
        <div className='col-12'>
          <div className='card '>
            <div className='card-header'>
              <div className='card-title fw-bolder'>สถิติจำนวนเสาในเสาเข็มแต่ละต้นที่ตอกสำเร็จ</div>
            </div>
            <div className='card-body'>
              <StackedPileChart
                chartId='kt_charts_stacked_pile_items_chart'
                categories={successfulPileHolesItemsData.categories}
                series={successfulPileHolesItemsData.data}
                colors={[
                  '#FF5B5B',
                  '#2D9CDB',
                  '#F2C94C',
                  '#6FCF97',
                  '#9B51E0',
                  '#56CCF2',
                  '#F2994A',
                  '#EB5757',
                  '#27AE60',
                  '#828282',
                ]}
                showDataLabels={false}
                chartHeight={650}
              />
            </div>
          </div>
        </div>
        {/* end:: Pile Item Stacked Chart */}

        {/* begin:: Issue Summary Chart */}
        <div className='col-xl-6 col-12'>
          <div className='card'>
            <div className='card-header'>
              <div className='card-title fw-bolder'>สรุปปัญหา</div>
            </div>
            <div className='card-body'>
              <IssueSummaryChart
                categories={issueData.categories}
                data={issueData.data}
                colors={['#b399fd']}
              />
            </div>
          </div>
        </div>
        {/* end:: Issue Summary Chart */}

        {/* begin:: Comparison Chart */}
        <div className='col-xl-6 col-12'>
          <div className='card'>
            <div className='card-header'>
              <div className='card-title fw-bolder'>เปรียบเทียบแต่ละหน่วยงาน</div>
            </div>

            <div className='card-body'>
              <ComparisonBarChart
                projects={projectStatusData.projects}
                data={projectStatusData.data}
                colors={['#b399fd', '#FC8497']}
              />
            </div>
          </div>
        </div>
        {/* end:: Comparison Chart */}

        <div className='row mb-5 gy-5'>
          {/* begin:: Progression Chart */}
          {/* <div className='col-xl-8 col-12'>
            <div className='card'>
              <div className='card-header'>
                <div className='card-title fw-bolder'>Progression</div>

                <div className='card-toolbar'>
                  <Select
                    placeholder='Year'
                    defaultValue={{ label: '2023', value: '2023' }}
                    options={[
                      {
                        label: '2023',
                        value: '2023',
                      },
                      {
                        label: '2022',
                        value: '2022',
                      },
                      {
                        label: '2021',
                        value: '2021',
                      },
                    ]}
                  />
                </div>
              </div>

              <div className='card-body'>
                {/* Date Range Selector
                <div className='button-group mb-3'>
                  <button
                    type='button'
                    className='btn btn-sm white-button left border border-2 w-100'>
                    1D
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button middle border border-2 w-100'>
                    1M
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button middle border border-2 w-100'>
                    3M
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button middle border border-2 w-100'>
                    1Y
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button right border border-2 w-100'>
                    YTD
                  </button>
                </div>

                {/* Chart
                <ProgressionChart color='#F26B4D' lightColor='#f5bdb1' />
              </div>
            </div>
          </div> */}
          {/* end:: Progression Chart */}
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '#',
            title: 'Dashboard',
            icon: '/media/icons/duotune/general/gen005.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'ผู้บริหาร',
          },
        ]}>
        ผู้บริหาร
      </PageTitle>

      {children}
    </>
  )
}

export default DashboardOverviewView
